import React from 'react';
import { DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Row, Col } from 'antd';

import PdButton from 'components/pd-button';

function SortableItem({ value = {}, sortIndex, removeMedia, editMedia }) {
  const { listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: value.id || sortIndex,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    userSelect: 'none',
  };

  const { secure_url, thumbnail_image, title } = value;

  return (
    <div ref={setNodeRef} style={style} className="draggable-item">
      <Row gutter={20}>
        <Col span={7} className="draggable-content over-hidden" {...listeners}>
          {secure_url && (
            <img
              alt={title + ' image'}
              className="w-full"
              height={200}
              src={thumbnail_image}
            />
          )}
        </Col>
        <Col span={12} className="draggable draggable-content" {...listeners}>
          <span className="fs-16">{title}</span>
        </Col>
        <Col span={5} className="draggable draggable-button">
          <PdButton
            className="height-32"
            onClick={(e) => { e.stopPropagation(); removeMedia(sortIndex); }}
            outline
            type="danger">
            Delete
          </PdButton>
          <PdButton
            className="height-32"
            onClick={(e) => { e.stopPropagation(); editMedia(sortIndex); }}
            type="primary">
            Edit
          </PdButton>
        </Col>
      </Row>
    </div>
  );
}

export default function ProductMedia({
  items,
  onSortEnd,
  removeMedia,
  editMedia,
}) {
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active && over && active.id !== over.id) {
      const oldIndex = items.findIndex((item) => (item.id || items.indexOf(item)) === active.id);
      const newIndex = items.findIndex((item) => (item.id || items.indexOf(item)) === over.id);
      onSortEnd({ oldIndex, newIndex });
    }
  };

  return (
    <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={items.map((item, index) => ({ id: item.id || index }))} strategy={verticalListSortingStrategy}>
        <div className="pd-sortable-product-media">
          {items.map((item, index) => (
            <SortableItem
              key={item.id || index}
              value={item}
              sortIndex={index}
              removeMedia={removeMedia}
              editMedia={editMedia}
            />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  );
}
